import { render, staticRenderFns } from "./payment-detail.vue?vue&type=template&id=839d8b9c&"
import script from "./payment-detail.vue?vue&type=script&lang=js&"
export * from "./payment-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports